import sampleData from "./sampleData.json";
import defaultProjectEn from "./defaultProject.en.json";
import defaultProjectNl from "./defaultProject.nl.json";
import demoProjectEn from "./demoProject.en.json";
import demoProjectNl from "./demoProject.nl.json";

export const PANEL_THICKNESSES = sampleData.panelThicknesses;
export const DEFAULT_THICKNESS_PRESETS = sampleData.defaultThicknessPresets;
export const PROJECT_COLORS = sampleData.projectColors;

const DEFAULT_BY_LOCALE = {
  en: defaultProjectEn,
  nl: defaultProjectNl,
};

const DEMO_BY_LOCALE = {
  en: demoProjectEn,
  nl: demoProjectNl,
};

function cloneJson(value) {
  return JSON.parse(JSON.stringify(value));
}

/** @param {string | undefined | null} locale */
export function normalizeFixtureLocale(locale) {
  return locale === "en" ? "en" : "nl";
}

function buildProjectFromLocaleData(localeData) {
  return {
    projectName: localeData.projectName,
    materialName: localeData.materialName,
    sourcePanel: cloneJson(sampleData.sourcePanel),
    werkplan: {
      ...cloneJson(sampleData.werkplan),
      generalNote: localeData.generalNote,
    },
    exportAnnotations: cloneJson(sampleData.exportAnnotations),
    restStock: [],
    projects: cloneJson(localeData.projects),
  };
}

/** @param {string | undefined | null} locale */
export function getDefaultProject(locale) {
  return buildProjectFromLocaleData(DEFAULT_BY_LOCALE[normalizeFixtureLocale(locale)]);
}

/** @param {string | undefined | null} locale */
export function getDemoProject(locale) {
  return buildProjectFromLocaleData(DEMO_BY_LOCALE[normalizeFixtureLocale(locale)]);
}

function normalizeThickness(value, fallback = 18) {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) && numericValue > 0 ? numericValue : fallback;
}

export { normalizeThickness as normalizePanelThickness };

export function makeId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  return `id-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function emptyPanel(defaultThickness = 18) {
  return {
    id: makeId(),
    name: "",
    length: "",
    width: "",
    thickness: normalizeThickness(defaultThickness),
    quantity: 1,
    hidden: false,
    edges: { top: false, right: false, bottom: false, left: false },
  };
}

export function emptySubproject(name = "Nieuw project", color = PROJECT_COLORS[0]) {
  return { id: makeId(), name, color, panels: [] };
}

/** Dutch default — used by golden tests and normalize fallbacks. */
export const DEFAULT_PROJECT = getDefaultProject("nl");

/** Dutch demo — canonical geometry for TEST-001 / golden tests. */
export const DEMO_PROJECT = getDemoProject("nl");

export const REAL_PROJECT = DEMO_PROJECT;
